module.exports = __webpack_public_path__ + "images/feature/20160720_2-f8fb0618724ae857fda1ceefb5fb2a66.jpg";